import * as React from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import * as Colors from '@themes/Colors'

export function FullScreenLoader() {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="small" color={Colors.alternateGray} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.altWhite,
  },
})
